import { Link } from "react-router-dom"
import {Mail, Phone, MapPin, ArrowUpRight} from 'lucide-react'

const footerLinks = {
  services: [
    { label: "Support informatique", path: "/services" },
    { label: "Maintenance", path: "/services" },
    { label: "Reseau & Infrastructure", path: "/services" },
    { label: "Sauvegarde & Securite", path: "/services" },
  ],
  support: [
    { label: "Ouvrir un ticket", path: "/support" },
    { label: "Espace client", path: "/support" },
    { label: "FAQ", path: "/support" },
    { label: "Statut des services", path: "/support" },
  ],
  entreprise: [
    { label: "A propos", path: "/a-propos" },
    { label: "Contact", path: "/contact" },
    { label: "Rendez-vous", path: "/rendez-vous" },
    { label: "Mentions legales", path: "/mentions-legales" },
  ],
}

export default function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800/50">
      <div className="section-padding py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center mb-5">
              <img
                src="https://static.lumi.new/3d/3d3904167daeab807172c4efcb0502aa.webp"
                alt="LJJ IT Logo"
                className="h-14 w-auto object-contain bg-white rounded-lg px-2 py-1"
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm mb-6">
              Votre partenaire informatique de confiance. Support technique, maintenance
              et infrastructure pour les PME et independants.
            </p>
            <div className="flex flex-col gap-3">
              <a href="mailto:contact@ljj-it.ch" className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400 transition-colors">
                <Mail className="w-4 h-4" /> contact@ljj-it.ch
              </a>
              <a href="tel:+41792489590" className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400 transition-colors">
                <Phone className="w-4 h-4" /> 0041 79 248 95 90
              </a>
              <span className="flex items-center gap-2 text-sm text-slate-400">
                <MapPin className="w-4 h-4" /> Lausanne, Suisse
              </span>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
                {title === "entreprise" ? "Entreprise" : title.charAt(0).toUpperCase() + title.slice(1)}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="group flex items-center gap-1 text-sm text-slate-400 hover:text-cyan-400 transition-colors"
                    >
                      {link.label}
                      <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-14 pt-8 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} LJJ IT. Tous droits reserves.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/mentions-legales" className="text-xs text-slate-500 hover:text-slate-300 transition-colors">
              Mentions legales
            </Link>
            <Link to="/mentions-legales" className="text-xs text-slate-500 hover:text-slate-300 transition-colors">
              Politique de confidentialite
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
